import { createContext } from 'react';
import { TwilioDevice } from './types';

export const TwilioContext = createContext<TwilioDevice | undefined>(undefined);
